export type ProductMatch = { barcode: string; name: string; category: string };

export function normalizeBarcode(value: string) { return value.replace(/\D/g, "").slice(0, 14); }
export function isSupportedBarcode(value: string) { return [8, 12, 13, 14].includes(normalizeBarcode(value).length); }

function foodKeepCategory(categories: string): string {
  const value = categories.toLowerCase();
  const matchers: Array<[string, RegExp]> = [
    ["Produce", /fruit|vegetable|produce/], ["Dairy", /milk|cheese|yogurt|dairy/],
    ["Meat", /meat|beef|pork|poultry|chicken/], ["Seafood", /fish|seafood/],
    ["Frozen", /frozen/], ["Beverages", /beverage|drink|juice|water|soda/],
    ["Snacks", /snack|chip|cracker|candy|chocolate/], ["Baking", /baking|flour|sugar/],
    ["Condiments", /sauce|condiment|spread/], ["Spices", /spice|seasoning/],
    ["Prepared Meals", /prepared|meal|pizza|soup/], ["Pet", /pet food|dog food|cat food/],
  ];
  return matchers.find(([, pattern]) => pattern.test(value))?.[0] || "";
}

export async function lookupProduct(rawBarcode: string, signal?: AbortSignal): Promise<ProductMatch | null> {
  const barcode = normalizeBarcode(rawBarcode);
  if (!isSupportedBarcode(barcode)) throw new Error("Enter an 8, 12, 13, or 14 digit UPC/EAN barcode.");
  const fields = "code,product_name,product_name_en,brands,categories,categories_tags";
  const response = await fetch(`https://world.openfoodfacts.org/api/v2/product/${encodeURIComponent(barcode)}.json?fields=${fields}`, { signal });
  if (!response.ok) throw new Error("Product lookup is unavailable right now. You can still enter the item manually.");
  const data = await response.json() as { status?: number; product?: { product_name?: string; product_name_en?: string; brands?: string; categories?: string; categories_tags?: string[] } };
  if (data.status !== 1 || !data.product) return null;
  const product = data.product;
  const productName = (product.product_name_en || product.product_name || "").trim();
  const brand = (product.brands || "").split(",")[0].trim();
  return { barcode, name: [brand, productName].filter(Boolean).join(" "), category: foodKeepCategory(product.categories || product.categories_tags?.join(" ") || "") };
}
